import Page from "../components/common/page";
import Reveal from "../components/common/reveal";
import { CAPABILITIES } from "../data/capabilities";
import { OPEN_SOURCE } from "../data/openSource";
import { SITE } from "../data/site";
import { TRAJECTORY } from "../data/work";

const DATE_COLOUR = {
	accent: "var(--accent)",
	sec: "var(--sec)",
	dim: "var(--dim)",
};

const Practice = () => (
	<Page page="practice" className="wrap page">
		<div className="kicker">Practice</div>
		<h1 className="h-page" style={{ maxWidth: "22ch" }}>
			What I do, and what it took to be able to do it
		</h1>

		<Reveal className="blk">
			<div className="seclabel" style={{ marginBottom: "32px" }}>
				Capability
			</div>
			<div className="hair-grid">
				{CAPABILITIES.map((capability) => (
					<div className="hair-cell" key={capability.heading}>
						<div className="cap-h">{capability.heading}</div>
						<p className="cap-p">{capability.description}</p>
						<div className="cap-tech">{capability.tech}</div>
					</div>
				))}
			</div>
		</Reveal>

		<Reveal className="blk-lg">
			<div className="seclabel" style={{ marginBottom: "32px" }}>
				Trajectory
			</div>
			{TRAJECTORY.map((role, index) => (
				<div
					key={role.years}
					className={
						"rule-top" +
						(index === TRAJECTORY.length - 1 ? " rule-bottom" : "")
					}
					style={{
						display: "flex",
						flexWrap: "wrap",
						gap: "24px",
						padding: role.collapsed ? "26px 0" : "30px 0",
					}}
				>
					<div
						className="mono"
						style={{
							flex: "0 0 150px",
							fontSize: "11px",
							color: DATE_COLOUR[role.tone],
						}}
					>
						{role.years}
					</div>
					<div style={{ flex: "1 1 420px", minWidth: 0 }}>
						{role.collapsed ? (
							<>
								<div
									style={{
										fontFamily: "Newsreader, serif",
										fontSize: "21px",
										fontWeight: 400,
										lineHeight: 1.3,
										color: "var(--sec)",
									}}
								>
									{role.title}
								</div>
								<p
									style={{
										fontSize: "15px",
										lineHeight: 1.68,
										color: "var(--dim)",
										margin: "10px 0 0",
										maxWidth: "62ch",
									}}
								>
									{role.description}
								</p>
							</>
						) : (
							<>
								<div className="role-title">{role.title}</div>
								<div
									className="secmeta"
									style={{ marginTop: "8px" }}
								>
									{role.meta}
								</div>
								<p
									className="p-body"
									style={{
										fontSize: "16px",
										marginTop: "16px",
									}}
								>
									{role.description}
								</p>
							</>
						)}
					</div>
				</div>
			))}
		</Reveal>

		<Reveal className="blk-lg">
			<div
				className="sec-head"
				style={{ marginBottom: "32px" }}
			>
				<div className="seclabel">Still building · open source</div>
				<a
					href={SITE.github}
					target="_blank"
					rel="noreferrer"
					className="link-plain"
				>
					github.com/anjanvb ↗
				</a>
			</div>

			<div className="split-tight">
				{OPEN_SOURCE.map((column) => (
					<div
						key={column.heading}
						style={{ flex: "1 1 300px", minWidth: 0 }}
					>
						<div className="col-head">{column.heading}</div>
						{column.entries.map((entry) => (
							<a
								key={entry.title}
								href={entry.link}
								target="_blank"
								rel="noreferrer"
								className="rule-bottom-soft"
								style={{
									display: "block",
									padding: "18px 0",
									textDecoration: "none",
								}}
							>
								<div className="oss-title">{entry.title}</div>
								<div className="oss-desc">
									{entry.description}
								</div>
							</a>
						))}
					</div>
				))}
			</div>
		</Reveal>
	</Page>
);

export default Practice;
